import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, Plus, Truck } from 'lucide-react';
import PartImage from '../PartImage/PartImage.jsx';
import { toCartItem, useCart } from '../../context/CartContext';
import { formatPrice } from '../../utils/fromat.js';
import './PartCard.css';

function PartCard({ part, compact = false }) {
    const { add } = useCart();
    const [justAdded, setJustAdded] = useState(false);
    const timer = useRef(null);
    const url = `/shop/product/${part.slug}`;

    useEffect(() => () => clearTimeout(timer.current), []);

    const handleAdd = () => {
        add(toCartItem(part), 1);
        setJustAdded(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setJustAdded(false), 1400);
    };

    return (
        <article className="part-card">
            <Link to={url} className="part-card__media" tabIndex={-1} aria-hidden="true">
                <PartImage src={part.image} alt="" />
                {part.is_featured && !compact && <span className="shop-badge">Хит</span>}
            </Link>

            <div className="part-card__body">
                <p className="part-card__meta">
                    {part.brand && <span className="part-card__brand">{part.brand}</span>}
                    <span className="part-card__sku">{part.part_number}</span>
                </p>

                <h3 className="part-card__title"><Link to={url}>{part.name}</Link></h3>

                {!compact && part.excerpt && <p className="part-card__excerpt">{part.excerpt}</p>}
                {!compact && part.fitment && (
                    <p className="part-card__fitment"><Truck size={18} /> {part.fitment}</p>
                )}

                <div className="part-card__footer">
                    <div className="part-card__price">
                        <strong>{formatPrice(part.price)}</strong>
                        {part.old_price && <s>{formatPrice(part.old_price)}</s>}
                    </div>

                    {compact ? (
                        <Link to={url} className="part-card__link">Подробнее</Link>
                    ) : (
                        <button
                            type="button"
                            className="shop-btn shop-btn--sm"
                            onClick={handleAdd}
                            disabled={!part.in_stock}
                        >
                            {!part.in_stock ? 'Нет в наличии' : justAdded ? <><Check size={18} /> Добавлено</> : <><Plus size={18} /> В корзину</>}
                        </button>
                    )}
                </div>
            </div>
        </article>
    );
}

export default React.memo(PartCard);
